"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsterisksDecorator = exports.Root = void 0;
const Checkbox_1 = require("@mui/material/Checkbox");
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const FormControlLabel_1 = require("@mui/material/FormControlLabel");
const FormHelperText_1 = require("@mui/material/FormHelperText");
const styles_1 = require("@mui/material/styles");
exports.Root = (0, styles_1.styled)(FormControl_1.default)(({ theme }) => ({
    [`& .${Checkbox_1.checkboxClasses.colorPrimary}`]: {
        color: theme.colours.inter,
        "&.Mui-disabled": {
            color: (0, styles_1.alpha)(theme.colours.inter, 0.25)
        }
    },
    [`& .${FormControlLabel_1.formControlLabelClasses.root}`]: {
        "&.Mui-error": {
            color: theme.colours.error400
        }
    },
    [`& .${FormControlLabel_1.formControlLabelClasses.error}`]: {
        [`& .${Checkbox_1.checkboxClasses.root}`]: {
            "&.Mui-checked": {
                color: theme.colours.error400
            }
        }
    },
    [`& .${FormControlLabel_1.formControlLabelClasses.label}`]: {
        marginTop: "1px",
        wordBreak: "break-word",
        marginLeft: 7
    },
    [`& .${FormHelperText_1.formHelperTextClasses.root}`]: {
        marginLeft: 14
    }
}));
exports.AsterisksDecorator = (0, styles_1.styled)("div")({
    position: "relative",
    "&::before": {
        content: '"*"',
        display: "block",
        position: "absolute",
        top: 0,
        marginTop: "9px"
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NoZWNrYm94L3N0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxxREFBeUQ7QUFDekQsNEVBQW9EO0FBQ3BELHFFQUF5RTtBQUN6RSxpRUFBcUU7QUFDckUsaURBQXFEO0FBRXhDLFFBQUEsSUFBSSxHQUFHLElBQUEsZUFBTSxFQUFDLHFCQUFXLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDdEQsQ0FBQyxNQUFNLDBCQUFlLENBQUMsWUFBWSxFQUFFLENBQUMsRUFBRTtRQUN0QyxLQUFLLEVBQUUsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLO1FBQzFCLGdCQUFnQixFQUFFO1lBQ2hCLEtBQUssRUFBRSxJQUFBLGNBQUssRUFBQyxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUssRUFBRSxJQUFJLENBQUM7U0FDeEM7S0FDRjtJQUNELENBQUMsTUFBTSwwQ0FBdUIsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ3RDLGFBQWEsRUFBRTtZQUNiLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLFFBQVE7U0FDOUI7S0FDRjtJQUNELENBQUMsTUFBTSwwQ0FBdUIsQ0FBQyxLQUFLLEVBQUUsQ0FBQyxFQUFFO1FBQ3ZDLENBQUMsTUFBTSwwQkFBZSxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7WUFDOUIsZUFBZSxFQUFFO2dCQUNmLEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLFFBQVE7YUFDOUI7U0FDRjtLQUNGO0lBQ0QsQ0FBQyxNQUFNLDBDQUF1QixDQUFDLEtBQUssRUFBRSxDQUFDLEVBQUU7UUFDdkMsU0FBUyxFQUFFLEtBQUs7UUFDaEIsU0FBUyxFQUFFLFlBQVk7UUFDdkIsVUFBVSxFQUFFLENBQUM7S0FDZDtJQUNELENBQUMsTUFBTSxzQ0FBcUIsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ3BDLFVBQVUsRUFBRSxFQUFFO0tBQ2Y7Q0FDRixDQUFDLENBQUMsQ0FBQztBQUVTLFFBQUEsa0JBQWtCLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUM7SUFDOUMsUUFBUSxFQUFFLFVBQVU7SUFDcEIsV0FBVyxFQUFFO1FBQ1gsT0FBTyxFQUFFLEtBQUs7UUFDZCxPQUFPLEVBQUUsT0FBTztRQUNoQixRQUFRLEVBQUUsVUFBVTtRQUNwQixHQUFHLEVBQUUsQ0FBQztRQUNOLFNBQVMsRUFBRSxLQUFLO0tBQ2pCO0NBQ0YsQ0FBQyxDQUFDIn0=